<div class="validation-errors-dialog">
  <div class="dialog-header">
    <div class="icon-container">
      <mat-icon>error</mat-icon>
    </div>
    <h2 mat-dialog-title>
      {{ data.title || 'Required Fields Incomplete' }}
    </h2>
  </div>
  <mat-dialog-content>
    <div class="dialog-body">
      @if (data.message) {
        <p class="intro-message">{{ data.message }}</p>
      }
      @if (data.issues?.length) {
        <ul class="validation-issues">
          @for (issue of data.issues; track issue) {
            <li>{{ issue }}</li>
          }
        </ul>
      }
    </div>
  </mat-dialog-content>
  <div class="dialog-actions">
    <button mat-raised-button (click)="onClose()" class="confirm-button">
      {{ data.confirmButtonText || 'Continue Editing' }}
    </button>
  </div>
</div>
